<template>
  <v-dialog v-model="variant_detail_dialog" persistent width="750">
    <v-card>
      <v-card-title class="my-0 py-2">Edit variant</v-card-title>
      <v-divider></v-divider>
      <p
        v-if="variant_dialog_error"
        style="background-color: #FFCDD2"
        class="pa-1 pl-5 ma-0 text-left"
      >{{variant_dialog_error_text}}</p>
      <v-divider v-if="variant_dialog_error"></v-divider>
      <v-card-text>
        <!--options-->
        <v-layout row v-for="(opt, ind) of current_item.variant_options" :key="ind+'A'">
          <v-flex md6 px-2>
            <v-text-field
              v-model="option_names[ind]"
              :label="opt.option_name"
              :autocomplete="NaN"
              :ref="'voption'+ind"
              :rules="[fieldRules.required]"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex md4 px-2>
            <vuetify-money
              v-model="current_item.price"
              label="Price"
              v-bind:options="current_item.price_currency == 'usd' ? moneyOptionsUSD : moneyOptions"
              @change="updateServicePrice"
            />
          </v-flex>
          <v-flex md2 px-2>
            <v-select
              v-model="current_item.price_currency"
              :label="$t('currency')"
              :items="currencies"
            />
          </v-flex>
          <v-flex md4 px-2>
            <vuetify-money
              v-model="current_item.cost"
              label="Cost"
              v-bind:options="current_item.cost_currency == 'usd' ? moneyOptionsUSD : moneyOptions"
            />
          </v-flex>
          <v-flex md2 px-2>
            <v-select
              v-model="current_item.cost_currency"
              :label="$t('currency')"
              :items="currencies"
            />
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex md4 px-2>
            <vuetify-money
              v-model="current_item.default_purchase_cost"
              label="Purchase cost"
              v-bind:options="current_item.purchase_cost_currency == 'usd' ? moneyOptionsUSD : moneyOptions"
            />
          </v-flex>
          <v-flex md2 px-2>
            <v-select
              v-model="current_item.purchase_cost_currency"
              :label="$t('currency')"
              :items="currencies"
            />
          </v-flex>
          <v-flex md6 px-2>
            <v-text-field
              v-model="current_item.sku"
              label="SKU"
              ref="sku"
              :rules="[fieldRules.required]"
              type="number"
              :autocomplete="NaN"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-title>Stores</v-card-title>
      <v-card-text>
        <v-data-table
          :mobile-breakpoint="0"
          v-bind:items="current_item.services"
          :items-per-page="200000"
          v-bind:headers="services_headers"
          hide-default-footer
        >
          <template v-slot:[`item.available`]="{item}">
            <v-checkbox v-model="item.available" />
          </template>
          <template v-slot:[`item.price`]="{item}">
            <vuetify-money
              v-model="item.price"
              v-bind:options="item.price_currency == 'usd' ? moneyOptionsUSD : moneyOptions"
              @input="item.price_auto_fill = false"
            />
          </template>
          <template v-slot:[`item.price_currency`]="{item}">
            <v-select
              v-model="item.price_currency"
              :items="currencies"
              :append-icon="''"
            />
          </template>
          <template v-slot:[`item.in_stock`]="{item}">
            <v-text-field v-model="item.in_stock" type="number" />
          </template>
          <template v-slot:[`item.low_stock`]="{item}">
            <v-text-field v-model="item.low_stock" type="number" />
          </template>
          <template v-slot:[`item.optimal_stock`]="{item}">
            <v-text-field v-model="item.optimal_stock" type="number" />
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="closeVariantDialog">{{$t('cancel')}}</v-btn>
        <v-btn
          v-if="addVariantLocal"
          text
          color="primary"
          :disabled="disable_save"
          @click="createItemVariantActionLocal"
        >{{$t('save')}}</v-btn>
        <v-btn
          v-else-if="updateVariantLocal"
          text
          color="primary"
          :disabled="disable_save"
          @click="updateItemVariant"
        >{{$t('save')}}</v-btn>
        <v-btn
          v-else
          text
          color="primary"
          :disabled="saveDisabled"
          @click="updateItemVariantActionGlobal"
        >{{$t('save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "VVariantDetailDialog",
  props: {
    variant_detail_dialog: Boolean,
    variant_dialog_error: {
      type: Boolean,
      default: false,
    },
    variant_dialog_error_text: {
      type: String,
      default: "Item with such SKU already exists.",
    },
    createItemVariant: {
      type: Function,
      default: () => {},
    },
    updateItemVariant: {
      type: Function,
      default: () => {},
    },
    closeVariantDialog: {
      type: Function,
      default: () => {},
    },
    updateServicePrice: {
      type: Function,
      default: () => {},
    },
    current_item: Object,
    services_headers: Array,
    option_names: Array,
    disable_save: Boolean,
    createItemVariantActionLocal: {
      type: Function,
      default: () => {},
    },
    updateItemVariantActionLocal: {
      type: Function,
      default: () => {},
    },
    updateItemVariantActionGlobal: {
      type: Function,
      default: () => {},
    },
    addVariantLocal: {
      type: Boolean,
      default: false,
    },
    updateVariantLocal: {
      type: Boolean,
      default: false,
    },
    updateVariantGlobal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    form() {
      const formObj = {
        sku: this.current_item.sku,
      };
      if (this.current_item && this.current_item.variant_options) {
        for (let i = 0; i < this.current_item.variant_options.length; i++) {
          formObj["voption" + i] = this.option_names[i];
        }
      }
      return formObj;
    },
    saveDisabled() {
      let formHasErrors = false;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
  }
};
</script>
